import s from '../allservices.jsx'

export function contactUsSubjectService(actionCallback) {

    fetch(s.contactUsSubject, {
        headers: new Headers({
            'Content-Type': 'application/json',
        })
    })
    .then(response => {
        if (response.status === 200) {
            response.json().then(json => actionCallback(json, "success"))
          
        }
        else if (response.status === 401) {
            let data = "signout."
            actionCallback(data, "Failure")
        }
        else {
            let data = "No Data."
            actionCallback(data, "emptyBody")
        }
    })
        // .then(response => {
        //     if (response.status === 202 || response.status === 200) {
        //         return response.json()
        //     }
        // })
        // .then(json => actionCallback(json));
}


// WEBPACK FOOTER //
// ./src/services/components/contactussubject.jsx